import { FILTER_ENUMS } from 'search/enums/constants';
import {
  IConstructorFacet,
  isIConstructorFacetMultiple,
  isIConstructorFacetRange,
} from 'shared/types/ConstructorFacet';

export const getBrandFacet = (facets: Array<IConstructorFacet>) => {
  const brandFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.BRAND);
  if (isIConstructorFacetMultiple(brandFacet) && brandFacet?.options?.length > 0) {
    return brandFacet;
  }

  return null;
};

export const getGenderFacet = (facets: Array<IConstructorFacet>) => {
  const genderFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.GENDER);
  if (isIConstructorFacetMultiple(genderFacet) && genderFacet?.options?.length > 0) {
    genderFacet.display_name = 'Gender';

    return genderFacet;
  }

  return null;
};

export const getConditionFacet = (facets: Array<IConstructorFacet>) => {
  const conditionFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.CONDITION);
  if (isIConstructorFacetMultiple(conditionFacet) && conditionFacet?.options?.length > 0) {
    return conditionFacet;
  }

  return null;
};

export const getYearFacet = (facets: Array<IConstructorFacet>) => {
  const yearFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.YEAR);
  if (isIConstructorFacetMultiple(yearFacet) && yearFacet?.options?.length > 0) {
    return yearFacet;
  }

  return null;
};

export const getYearBucketFacet = (facets: Array<IConstructorFacet>) => {
  const yearBucketFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.YEAR_BUCKET);
  if (isIConstructorFacetMultiple(yearBucketFacet) && yearBucketFacet?.options?.length > 0) {
    return yearBucketFacet;
  }

  return null;
};

export const getColorFacet = (facets: Array<IConstructorFacet>) => {
  const colorFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.COLOR);
  if (isIConstructorFacetMultiple(colorFacet) && colorFacet?.options?.length > 0) {
    return colorFacet;
  }

  return null;
};

export const getInstantShipFacet = (facets: Array<IConstructorFacet>) => {
  const instantShipFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.INSTANT_SHIP);
  if (isIConstructorFacetRange(instantShipFacet) && instantShipFacet) {
    return instantShipFacet;
  }

  return null;
};

export const getPriceFacet = (facets: Array<IConstructorFacet>) => {
  const priceFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.PRICE);

  if (isIConstructorFacetRange(priceFacet) && priceFacet) {
    if (priceFacet.min === priceFacet.max) {
      return null;
    }
    return priceFacet;
  }

  return null;
};

export const getDiscountTagFacet = (facets: Array<IConstructorFacet>) => {
  const discountTagFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.DISCOUNT_TAG);
  if (isIConstructorFacetMultiple(discountTagFacet) && discountTagFacet?.options?.length > 0) {
    return discountTagFacet;
  }

  return null;
};

export const getMobilePriceFacet = (facets: Array<IConstructorFacet>) => {
  const priceFacet = getPriceFacet(facets);
  const discountTagFacet = getDiscountTagFacet(facets);
  if (isIConstructorFacetRange(priceFacet) && priceFacet) {
    if (isIConstructorFacetMultiple(discountTagFacet) && discountTagFacet) {
      return { ...priceFacet, options: discountTagFacet.options };
    }
    return priceFacet;
  }

  return null;
};

export const getPriceBucketFacet = (facets: Array<IConstructorFacet>) => {
  const priceBucket = facets?.find((facet) => facet?.name === FILTER_ENUMS.PRICE_BUCKET);
  if (isIConstructorFacetMultiple(priceBucket) && priceBucket?.options?.length > 0) {
    return priceBucket;
  }

  return null;
};

export const getCategoryFacet = (facets: Array<IConstructorFacet>) => {
  const categoryFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.CATEGORY);

  if (isIConstructorFacetMultiple(categoryFacet) && categoryFacet?.options?.length > 0) {
    return categoryFacet;
  }

  return null;
};

export const getSizeFacet = (facets: Array<IConstructorFacet>) => {
  const sizeFacet = facets?.find((facet) => facet?.name === FILTER_ENUMS.SIZE);

  if (isIConstructorFacetMultiple(sizeFacet) && sizeFacet?.options?.length > 0) {
    return sizeFacet;
  }

  return null;
};

export const getAvailableNowFacet = (facets: Array<IConstructorFacet>) => {
  const availableNowFacet = facets.find((facet) => facet?.name === FILTER_ENUMS.AVAILABLE_NOW);
  if (isIConstructorFacetMultiple(availableNowFacet)) {
    const isAvailableNow = availableNowFacet?.options?.find((option) => option.value === 'True');

    if (isAvailableNow?.count > 0) {
      return availableNowFacet;
    }
  }

  return null;
};
